import { render } from "./gWattMinM3Modal.vue?vue&type=template&id=07ed6ef6&ts=true"
import script from "./gWattMinM3Modal.vue?vue&type=script&lang=ts"
export * from "./gWattMinM3Modal.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__